// Wave-B harness — despacho exaustivo de finish_reason (doutrina Claude:
// "stop_reason não é erro; faça branch exaustivo e trate truncamento com
// continuação BOUNDED"). Puro; o agentLoop aplica. Multi-provider: normaliza
// OpenAI (stop|length|tool_calls|content_filter) e Anthropic (end_turn|
// max_tokens|tool_use|refusal). Ausente/desconhecido ⇒ 'ok' (zero mudança
// de comportamento para providers que não reportam).

const TRUNCATED = new Set(['length', 'max_tokens', 'model_length', 'MAX_TOKENS']);
const FILTERED = new Set(['content_filter', 'refusal', 'safety', 'RECITATION']);

/** @param {any} reply @returns {'ok'|'truncated'|'filtered'} */
export function classifyFinish(reply) {
  const raw = reply?.finish_reason ?? reply?.stop_reason ?? reply?.finishReason;
  if (typeof raw !== 'string' || !raw) return 'ok';
  if (TRUNCATED.has(raw)) return 'truncated';
  if (FILTERED.has(raw)) return 'filtered';
  return 'ok';
}

// Regra oficial: NUNCA "resumir" um tool_use cortado — continuação só vale para
// TEXTO truncado. Tool call cortada já cai no caminho __argsError/re-steer do loop.
export function shouldContinueTruncated({ kind, toolCallCount, alreadyContinued }) {
  return kind === 'truncated' && toolCallCount === 0 && !alreadyContinued;
}

export function buildContinuationNudge() {
  return [
    '[HARNESS] Sua resposta anterior foi TRUNCADA pelo limite de tokens (finish_reason=length).',
    'Continue EXATAMENTE de onde parou — não repita o que já escreveu, não recomece.',
    'Se estava no meio de um arquivo/bloco de código, retome do ponto do corte.',
  ].join(' ');
}

/** Nota honesta anexada quando a continuação também truncou (2º corte ⇒ entrega parcial declarada). */
export function truncationNotice() {
  return '\n\n[saída truncada pelo limite de tokens do modelo — parte final ausente]';
}

/**
 * Decisão única pro spine (1 call, branches aqui): null = seguir normal;
 * {kind:'continue'} = truncou texto ⇒ 1 retomada; {kind:'filtered'} = stop
 * honesto; {kind:'note'} = 2º corte ⇒ entrega parcial declarada.
 * @param {any} reply @param {number} toolCallCount @param {boolean} alreadyContinued
 */
export function resolveFinishAction(reply, toolCallCount, alreadyContinued) {
  const kind = classifyFinish(reply);
  if (kind === 'filtered') {
    const raw = reply?.finish_reason ?? reply?.stop_reason;
    return { kind: 'filtered', error: `Resposta bloqueada pelo filtro de conteúdo do provider (finish_reason=${raw}).` };
  }
  if (kind !== 'truncated') return null;
  if (shouldContinueTruncated({ kind, toolCallCount, alreadyContinued })) {
    return { kind: 'continue', nudge: buildContinuationNudge() };
  }
  // Truncou no meio de tool_calls: o caminho __argsError/re-steer do loop já cobre.
  return toolCallCount === 0 ? { kind: 'note', note: truncationNotice() } : null;
}
